/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { TerminalConnectOrgConfig } from '../model';
/**
 * TerminalConnectApi - axios parameter creator
 * @export
 */
export const TerminalConnectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Bloomberg Terminal Connect config for the current user\'s organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminalConnectOrgConfig: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/shared/terminal-connect/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TerminalConnectApi - functional programming interface
 * @export
 */
export const TerminalConnectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TerminalConnectApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Bloomberg Terminal Connect config for the current user\'s organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTerminalConnectOrgConfig(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TerminalConnectOrgConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTerminalConnectOrgConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TerminalConnectApi - factory interface
 * @export
 */
export const TerminalConnectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TerminalConnectApiFp(configuration)
    return {
        /**
         * 
         * @summary Bloomberg Terminal Connect config for the current user\'s organization
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTerminalConnectOrgConfig(options?: any): AxiosPromise<TerminalConnectOrgConfig> {
            return localVarFp.getTerminalConnectOrgConfig(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TerminalConnectApi - object-oriented interface
 * @export
 * @class TerminalConnectApi
 * @extends {BaseAPI}
 */
export class TerminalConnectApi extends BaseAPI {
    /**
     * 
     * @summary Bloomberg Terminal Connect config for the current user\'s organization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TerminalConnectApi
     */
    public getTerminalConnectOrgConfig(options?: any) {
        return TerminalConnectApiFp(this.configuration).getTerminalConnectOrgConfig(options).then((request) => request(this.axios, this.basePath));
    }
}
